var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInspire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            path, rect\n            {\n                fill: #263c53;\n            }\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 161.64,
    y: 57.92,
    width: 28.11,
    height: 15,
    transform: "translate(5.17 143.33) rotate(-44.98)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 184.85,
    y: 113.94,
    width: 28.11,
    height: 15
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 168.19,
    y: 163.42,
    width: 15,
    height: 28.11,
    transform: "translate(-74.03 176.31) rotate(-45.02)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 112.17,
    y: 186.62,
    width: 15,
    height: 28.11
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 49.59,
    y: 169.97,
    width: 28.1,
    height: 15,
    transform: "translate(-106.85 96.98) rotate(-45)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 26.37,
    y: 113.94,
    width: 28.13,
    height: 15
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 56.15,
    y: 51.37,
    width: 15,
    height: 28.1,
    transform: "translate(-27.62 64.16) rotate(-45)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 112.17,
    y: 28.15,
    width: 15,
    height: 28.13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.93,121.44a51.26,51.26,0,1,0-51.26,51.26A51.31,51.31,0,0,0,170.93,121.44ZM119.67,157.7a36.26,36.26,0,1,1,36.26-36.26A36.3,36.3,0,0,1,119.67,157.7Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspire);
export default __webpack_public_path__ + "static/media/inspire.10ba1632ed98bd1d23d3929cf500f659.svg";
export { ForwardRef as ReactComponent };